import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { MenuItem } from "../../../objects/components/menuItem";
import { StorageManager } from "../../../common/managers/storageManager";
import * as ps from "perfect-scrollbar";
import { BaseMenuComponent } from "../../../common/menu/baseMenuComponent";

@Component({
    selector: 'side-bar',
    templateUrl: './sideBar.component.html',
    styleUrls: ['../../../../theme/css/sideBar.css'],
    moduleId: module.id.toString()
})
export class SideBarComponent extends BaseMenuComponent implements OnInit, AfterViewInit {
    public appName: Promise<string>;
    @Input() public isMobileMenu: boolean;

    @Input() public menuItems: Array<MenuItem>;
    @ViewChild("sidebar") sidebar: ElementRef;

    constructor(router: Router, storageManager: StorageManager) {
        super(storageManager, router);
    }

    ngOnInit(): void {
        ps.initialize(this.sidebar.nativeElement);
        
        this.appName = new Promise((resolve, reject) => resolve("Border Buddy"));
        this.toggleButton = document.getElementsByClassName('navbar-toggle')[0];
    }

    async ngAfterViewInit(): Promise<void> {
    }

    logout(): void {
        this.storageManager.logout();

        this.router.navigate(['/auth/login']);
    }
}


// WEBPACK FOOTER //
// ./app/components/sidebar/sideBar/sideBar.component.ts